import { buildScenarioRules } from '@/helpers/rulesModules/buildScenarioRules';
import { buildPvRules } from '@/helpers/rulesModules/buildPvRules';
import { buildEcoRules } from '@/helpers/rulesModules/buildEcoRules';

interface Dependencies {
  fileLoader: <T>(fileName: string) => Promise<{data: T}>
}

export const rulesGenerator = async({ fileLoader }: Dependencies) => {
  const { data } = await fileLoader<Record<string, unknown>>('pv_references');
  const PVModelOptions = Object.keys(data);
  return buildScenarioRules({
    buildPvRules: () => buildPvRules({ pvModelOptions: PVModelOptions }),
    buildEcoRules: () => buildEcoRules()
  });
};

/**
 * @deprecated We need to stop using the global variable and use scenarioRule store module instead
 * PVModelOptions does not need to be initialised by default, it is overridden when a project is loaded (@see src/store/modules/project.ts#setCurrentProject)
 */
export default buildScenarioRules({
  buildPvRules: () => buildPvRules({ pvModelOptions: [] }),
  buildEcoRules: () => buildEcoRules()
});
